import {createApi} from '@reduxjs/toolkit/dist/query/react'
import {baseQueryWithReauth} from './BaseQueryReauth'
import {GeneratePromptTemplate, PromptTemplate} from '../modules/cdr/core/_models'

export const promptAPI = createApi({
  reducerPath: 'promtAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['prompts'],
  endpoints: (build) => ({
    getPrompts: build.query<PromptTemplate[], string>({
      query: (app_id) => ({
        url: `/extensions/prompts/${app_id}`,
      }),
      providesTags: [{type: 'prompts', id: 'LIST'}],
    }),
    createPrompt: build.mutation<void, {app_id: string; prompt: PromptTemplate}>({
      query: ({app_id, prompt}) => ({
        method: 'POST',
        url: `/extensions/prompts/${app_id}`,
        body: prompt,
      }),
      invalidatesTags: [{type: 'prompts', id: 'LIST'}],
    }),
    generatePrompt: build.mutation<Record<string, any>, {app_id: string; data: GeneratePromptTemplate}>({
      query: ({app_id, data}) => ({
        method: 'POST',
        url: `/extensions/prompts/${app_id}/generate`,
        body: data,
      }),
    }),
    updatePrompt: build.mutation<void, {app_id: string; data: PromptTemplate}>({
      query: ({app_id, data}) => ({
        method: 'PATCH',
        url: `/extensions/prompts/${app_id}`,
        body: data,
      }),
      invalidatesTags: [{type: 'prompts', id: 'LIST'}],
    }),
    deletePrompt: build.mutation<void, {app_id: string; prompt_id: string}>({
      query: ({app_id, prompt_id}) => ({
        method: 'DELETE',
        url: `/extensions/prompts/${app_id}/${prompt_id}`,
      }),
      invalidatesTags: ['prompts'],
    }),
  }),
})
